// While an upload of class notes (or a book outline, `data-upload-poll`) is
// being read, asks the server whether it
// is done and reloads the page when it is — the server renders the coverage,
// so the browser only needs to know when.
//
// NOT IN packs/, for the reason mock_composer.js records; imported by
// packs/application.js beside course_report_poll.js, whose shape this is.
//
// Never reloads over a half-filled upload form: a student naming their next
// lecture while the last one is read keeps what they typed, and the page
// waits for them to leave the form alone. Without this module the page still
// works — a reload by hand shows the same thing.

const POLL_MS = 5000;

function setup() {
  const root = document.querySelector("[data-class-notes-poll], [data-upload-poll]");
  if (root === null) return;

  const url = root.dataset.classNotesPoll || root.dataset.uploadPoll;
  const form = root.querySelector("[data-poll-form], .class-notes__form");
  let touched = false;
  if (form) form.addEventListener("input", () => { touched = true; });

  function tick() {
    fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data && data.in_flight === false && !touched) return window.location.reload();
        return schedule();
      })
      .catch(schedule);
  }

  function schedule() {
    window.setTimeout(tick, POLL_MS);
  }

  schedule();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup);
} else {
  setup();
}
